import { Form, Select } from "antd";
import { Checkbox } from "../../../BP2Components";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDebouncedCallback } from "use-debounce";
import { useFormContext } from "../../../../context/FormContext/FormContext";
import { handleChangedRelatedField, handleGridTechname, renderDevInfo } from "../../GeneralScripts";
import PropTypes from "prop-types";
import "./CheckboxField.less";
import FieldInfo from "../FieldInfo/FieldInfo";
import { getAllFieldsWithAlerts, handleTemplateAlert } from "../../../../util/Scripts";

const { Option } = Select;

const CheckboxField = ({
   isRequired,
   element,
   form,
   isVisible,
   disabled,
   formId,
   insideGrid = false,
   rowDataId,
   initialValue,
}) => {
   const intl = useIntl();
   const { getFieldDecorator } = form;
   const [options, setOptions] = useState([]);
   const { formData, changeFieldPendingStatus, fieldsInfo, setFieldsInfo, fieldEnumMap } =
      useFormContext();
   const [infoText, setInfoText] = useState(null);
   const handleValueChange = useDebouncedCallback(() => {
      const allFieldsWithAlerts = getAllFieldsWithAlerts(formData?.forms_data?.tab?.[0]?.elements);
      handleChangedRelatedField(
         element,
         form,
         setFieldsInfo,
         allFieldsWithAlerts,
         formId,
         intl,
         formData._formKey,
         rowDataId,
         changeFieldPendingStatus,
         fieldEnumMap,
      );
   }, 1000);

   useEffect(() => {
      let elementOptions = [];
      if (element && element.sortedOptions) {
         for (const property in element.sortedOptions) {
            const sortedElement = element.sortedOptions[property];
            const sortedElementKey = Object.keys(sortedElement)[0];
            elementOptions.push({
               label: sortedElement[sortedElementKey],
               value: sortedElementKey,
            });
         }
      }
      setOptions(elementOptions);
   }, []);
   const translatedLabel = element.label;

   useEffect(() => {
      const infoText = fieldsInfo[element.tech_name];
      setInfoText(infoText);
      handleTemplateAlert(element.tech_name, infoText);
   }, [fieldsInfo[element.tech_name]]);

   return (
      <Form.Item
         key={element.tech_name}
         label={!insideGrid && translatedLabel}
         className={`${element?.type}-field`}
         style={{
            display: isVisible(element) ? "" : "none",
            gridArea: handleGridTechname(element.tech_name),
         }}
      >
         {getFieldDecorator(element.tech_name, {
            rules: [
               {
                  required: isRequired(element),
                  message: intl.formatMessage({ id: "field.required" }),
               },
            ],
            initialValue: initialValue ?? element.value,
         })(
            // In Checkboxes element this indicates if it should be rendered as multiselect or normal checkbox
            element.object?.UIP_NUM4 === "1" ? (
               <Select
                  mode="multiple"
                  disabled={disabled}
                  onChange={handleValueChange}
                  className={`checkbox-field__select field_${element.tech_name} _type_${element?.type}_type_`}
               >
                  {options?.map((option) => (
                     <Option value={option.value} key={option.value} id={option.value}>
                        {option.label}
                     </Option>
                  ))}
               </Select>
            ) : (
               <Checkbox.Group
                  options={options}
                  onChange={handleValueChange}
                  disabled={disabled}
                  className={`field_${element.tech_name}`}
               />
            ),
         )}
         {renderDevInfo(element)}
         <FieldInfo text={infoText} />
      </Form.Item>
   );
};

CheckboxField.propTypes = {
   element: PropTypes.object.isRequired,
   disabled: PropTypes.bool,
   isVisible: PropTypes.func,
   form: PropTypes.any,
   formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   initialValue: PropTypes.arrayOf(PropTypes.string),
};

export default CheckboxField;
